/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { task } from 'ember-concurrency';
import { tracked } from '@glimmer/tracking';
import ExportModel from 'cio/models/export';

interface ExportRowArgs {
  export: ExportModel;
  download: (export_id: string) => unknown;
  performAutoDownload: boolean;
}

export default class ExportRow extends Component<ExportRowArgs> {
  @tracked showWarningModal = false;

  downloadTask = task({ drop: true }, async () => {
    if (this.args.export.type === 'profile_data' && !this.showWarningModal) {
      this.showWarningModal = true;
    } else {
      this.showWarningModal = false;
      await this.args.download(this.args.export.id);
    }
  });

  @action
  checkAutoDownload() {
    if (this.args.performAutoDownload) {
      this.downloadTask.perform();
    }
  }

  @action
  closeWarningModal() {
    this.showWarningModal = false;
  }
}
